import React, { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory, useLocation, useParams, Link } from 'react-router-dom'
import { LangValue } from '../../../states/types/common'
import { setPath } from '../../../utils/url'
import CardList from '../../components/common/CardList'
import EXPORT_LIST from '../../constants/export'
import { URL } from '../../constants/url'

const Index: FC = () => {
  const { language } = useParams<{ language: LangValue }>()
  const history = useHistory()
  const location = useLocation()

  const clickContents = (url: string) => {
    history.push(`${setPath(url, language)}`)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <section className="export_page">
      <Helmet>
        <title>Qasee - 組織分析 - データエクスポート</title>
      </Helmet>
      <section className="breadcrumb">
        <Link
          to={setPath(URL.ANALYZE.path, language)}
        >
          組織分析
        </Link>
        &nbsp;&gt;&nbsp;
        データエクスポート
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          データエクスポート
        </h1>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-header">
            <div className="title">
              データエクスポート一覧
            </div>
          </div>
          <div className="block-detail">
            <CardList
              clickCallback={clickContents}
              list={EXPORT_LIST}
            />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
